import { useEffect, useState } from 'react';
import { useNavegate } from 'App/hooks';
import { useForm, useToastStatus } from 'commons/hooks';
import { useGetInvoiceInfo } from 'domains/Billing/Invoices/hooks';
import useTranslationBilling from 'domains/Billing/useTranslationBilling';
import { FiscalDataformChile } from './components/ChileanFiscalDataForm';
import ChileanFiscalDataForm from './components/ChileanFiscalDataForm/ChileanFiscalDataForm';
import useChileanFiscalData from './useChileanFiscalData';
import validationSchema from './validationSchema';

const defaultValues = {
  address: '',
  name: '',
  numberId: '',
};

function ChileanFiscalData() {
  const t = useTranslationBilling();
  const { createFiscalData, updateFiscalData, status, cleanData } =
    useChileanFiscalData();
  const { goBack } = useNavegate();

  const { invoiceInfo, fetchInvoiceInfo, isLoading, hasInvoiceInfo } =
    useGetInvoiceInfo();

  const [initialValues, setInitialValues] = useState(defaultValues);

  const { errors, values, setFieldValue, handleOnSubmit, isDirty } =
    useForm<FiscalDataformChile>({
      initialValues,
      validationSchema,
      onSubmit: (data) => {
        if (hasInvoiceInfo) {
          updateFiscalData(data);
        } else {
          createFiscalData(data);
        }
      },
    });

  useEffect(() => {
    if (invoiceInfo) {
      setInitialValues({
        address: invoiceInfo.address,
        name: invoiceInfo.name,
        numberId: invoiceInfo.numberId,
      });
    }
  }, [invoiceInfo, setInitialValues]);
  useEffect(() => {
    fetchInvoiceInfo();
  }, [fetchInvoiceInfo]);

  const onChange = ({ name, value }) => setFieldValue(name, value);

  useToastStatus({
    error: t('invoicesInfoPage.error'),
    success: t('invoicesInfoPage.success'),
    status,
    onSuccess: () => {
      cleanData();
      goBack();
    },
  });

  return isLoading ? (
    <ChileanFiscalDataForm.Skeleton onCancel={goBack} />
  ) : (
    <ChileanFiscalDataForm
      onSave={handleOnSubmit}
      onCancel={goBack}
      onChange={onChange}
      values={values}
      errors={errors}
      isLoading={status === 'loading' || isLoading}
      isDirty={isDirty}
    />
  );
}

export default ChileanFiscalData;
